import { ApolloError } from '@apollo/client';
import { UpdateRodRequestErrorCode } from '@bechtel/types';

export type UpdateRodRequestErrorType = UpdateRodRequestErrorCode | ApolloError;

export interface UpdateRodRequestErrorProps {
  error: UpdateRodRequestErrorType;
  close: () => void;
}
